define('models/StateCollection',['underscore', 'ObjectCollection', 'LocalStorage', 'models/StoreModel'], function (_, ObjectCollection, LocalStorage, StoreModel) {
    //
    // Collection Store
    //
    var StateCollectionPrototype = {

        name: 'StateCollection',
        route: 'apiStateCollection',
        model: StoreModel,
        bundleId:'states',
        international:false,

        initialize: function () {
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);
            //
        },
        setupInternational:function(){
            this.international = false;
        },

        getById: function(id_state) {
            return this.findWhere({id_state: id_state})
        },
        getByLinkSEO: function(link_rewrite) {
            return this.findWhere({link_rewrite: link_rewrite})
        }
    };

    var StateCollection = ObjectCollection.extend(LocalStorage).extend(StateCollectionPrototype);

    return StateCollection;
});

